/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconPagePreviousLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 10 10">
    <g transform="matrix(-1,0,0,1,492.0040588378906,0)">
    <g>
        <path d="M489.5,4.6L485,0.2c-0.1-0.1-0.2-0.2-0.4-0.2c-0.1,0-0.3,0.1-0.4,0.2l-0.3,0.3c-0.2,0.2-0.2,0.6,0,0.8 l3.7,3.7l-3.7,3.7c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.1,0.1,0.3,0.2,0.4l0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.3-0.1,0.4-0.2 l4.5-4.5c0.1-0.1,0.2-0.2,0.2-0.4C489.6,4.9,489.6,4.7,489.5,4.6z" />
    </g>
</g>
  </Icon>
);
};

IconPagePreviousLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDEwIDEwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMCAxMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgoJCTxnIHRyYW5zZm9ybT0ibWF0cml4KC0xLDAsMCwxLDQ5Mi4wMDQwNTg4Mzc4OTA2LDApIj4KCQkJPGc+CgkJCQk8cGF0aCBkPSJNNDg5LjUsNC42TDQ4NSwwLjJjLTAuMS0wLjEtMC4yLTAuMi0wLjQtMC4yYy0wLjEsMC0wLjMsMC4xLTAuNCwwLjJsLTAuMywwLjNjLTAuMiwwLjItMC4yLDAuNiwwLDAuOCBsMy43LDMuN2wtMy43LDMuN2MtMC4xLDAuMS0wLjIsMC4yLTAuMiwwLjRjMCwwLjEsMC4xLDAuMywwLjIsMC40bDAuMywwLjNjMC4xLDAuMSwwLjIsMC4yLDAuNCwwLjJjMC4xLDAsMC4zLTAuMSwwLjQtMC4yIGw0LjUtNC41YzAuMS0wLjEsMC4yLTAuMiwwLjItMC40QzQ4OS42LDQuOSw0ODkuNiw0LjcsNDg5LjUsNC42eiIvPgoJCQkJPC9nPgoJCQk8L2c+CgkJPC9zdmc+";
IconPagePreviousLineComponent.Content = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 10 10" style="enable-background:new 0 0 10 10;" xml:space="preserve">
		<g transform="matrix(-1,0,0,1,492.0040588378906,0)">
			<g>
				<path d="M489.5,4.6L485,0.2c-0.1-0.1-0.2-0.2-0.4-0.2c-0.1,0-0.3,0.1-0.4,0.2l-0.3,0.3c-0.2,0.2-0.2,0.6,0,0.8 l3.7,3.7l-3.7,3.7c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.1,0.1,0.3,0.2,0.4l0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.3-0.1,0.4-0.2 l4.5-4.5c0.1-0.1,0.2-0.2,0.2-0.4C489.6,4.9,489.6,4.7,489.5,4.6z"/>
				</g>
			</g>
		</svg>`;

const IconPagePreviousLine = styled(IconPagePreviousLineComponent)``;

export default IconPagePreviousLine;
